module.exports = __webpack_public_path__ + "static/media/glass1.941f853d.svg";